module.exports = __webpack_public_path__ + "assets/208f269984cb475137b76e2e3b82d313.svg";